import { render, staticRenderFns } from "./DraggableElements.vue?vue&type=template&id=4c66e0ac&scoped=true"
import script from "./DraggableElements.vue?vue&type=script&lang=js"
export * from "./DraggableElements.vue?vue&type=script&lang=js"
import style0 from "./DraggableElements.vue?vue&type=style&index=0&id=4c66e0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66e0ac",
  null
  
)

export default component.exports